export default __webpack_public_path__ + "static/media/JoinBot.985a342b.svg";